import moment from 'moment'

export function formatDateTime(dateTimeIso?: string, sep?: string): string {
  const format = sep ? `DD.MM.YYYY${sep}HH:mm` : 'DD.MM.YYYY - HH:mm'
  return dateTimeIso ? moment(dateTimeIso).format(format) : ''
}
export function formatDate(dateTimeIso?: string): string {
  return dateTimeIso ? moment(dateTimeIso).format('DD.MM.YYYY') : ''
}
